// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForwardMessageFooterView__container-b706b3 {
  width: 100%;
}

.ForwardMessageFooterView__input-container-f91ff2 {
  margin-bottom: 16px;
}

.ForwardMessageFooterView__input-e732c7 {
  max-height: 150px;
}

.ForwardMessageFooterView__submit-btn-be556e {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/ForwardMessageFooterView/ForwardMessageFooterView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AACF","sourcesContent":[".container {\n  width: 100%;\n}\n\n.input-container {\n  margin-bottom: 16px;\n}\n\n.input {\n  max-height: 150px;\n}\n\n.submit-btn {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ForwardMessageFooterView__container-b706b3`,
	"input-container": `ForwardMessageFooterView__input-container-f91ff2`,
	"inputContainer": `ForwardMessageFooterView__input-container-f91ff2`,
	"input": `ForwardMessageFooterView__input-e732c7`,
	"submit-btn": `ForwardMessageFooterView__submit-btn-be556e`,
	"submitBtn": `ForwardMessageFooterView__submit-btn-be556e`
};
module.exports = ___CSS_LOADER_EXPORT___;
